import React from 'react';
import { observer } from 'mobx-react-lite';
function getCount(count) {
    if (typeof count === 'function') {
        return count();
    }
    return count;
}
const Count = observer(function Count(props) {
    const { count, overflowCount, prefixCls } = props;
    const number = getCount(count);
    if (number) {
        return (React.createElement("span", { className: `${prefixCls}-tab-count` }, overflowCount && number > overflowCount ? `${overflowCount}+` : number));
    }
    return null;
});
Count.displayName = 'Count';
export default Count;
